import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { SchoolIncidentInsertRequest } from "./SchoolIncidentInsertRequest";
import { SchoolIncidentUpdateRequest } from "./SchoolIncidentUpdateRequest";

@Injectable()
export class DataService_SchoolIncidentSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadSchoolIncident(SchoolID, StartDT, StopDT) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/LoadSchoolIncident?SchoolID=" + SchoolID + "&StartDT=" + StartDT + "&StopDT=" + StopDT;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolIncidentInsert(parms: SchoolIncidentInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SchoolIncidentInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolIncidentUpdate(parms: SchoolIncidentUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SchoolIncidentUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolIncidentDelete(SchoolIncidentID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SchoolIncidentDelete?SchoolIncidentID=" + SchoolIncidentID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolIncidentTypeSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SchoolIncidentTypeSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
